/* FDWS Homepage — carousel arrows + quick add */
(function () {
  if (window.__fdwsHome) return;
  window.__fdwsHome = true;

  function initCarousel(root) {
    if (root.dataset.fdwsInit) return;
    root.dataset.fdwsInit = '1';
    var track = root.querySelector('.fdws-track');
    if (!track) return;
    var prev = root.querySelector('[data-fdws-prev]');
    var next = root.querySelector('[data-fdws-next]');

    function update() {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function step() {
      var item = track.querySelector('li');
      if (!item) return track.clientWidth * 0.8;
      var w = item.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (w + gap)) - 1);
      return (w + gap) * perView;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fdws-carousel]').forEach(initCarousel);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Quick add — plugs into Dawn's cart notification / cart drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-fdws-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { window.location.href = form.dataset.productUrl || '/cart'; return; }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fdws-quick-add', productVariantId: fd.get('id'), cartData: res });
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });
})();
